module.exports = __webpack_public_path__ + "static/media/cilindros-normal.e6a77311.svg";